import { createFollowUpCommandHandler } from '$tablet-app/src/app/chat/commands/handleFollowupInputCommand';
import { CommandTypes } from '$tablet-app/src/app/chat/commands/types';
import { LoginScreenState } from '../login_screen_state';

type Params = {
  commands: any[];
  getState(): LoginScreenState;
};

export function processCommands(params: Params) {
  const { commands, getState } = params;

  for (const command of commands) {
    switch (command.type) {
      case CommandTypes.FOLLOW_UP_INPUT: {
        createFollowUpCommandHandler({
          sendMessage: getState().sendMessage,
          sendLabel: getState().sendLabel,
        })(command);
        break;
      }

      case 'close_welcome': {
        getState().closeWelcome();
        break;
      }

      case 'set_username': {
        getState().setUsername(command.data.value);
        break;
      }

      case 'set_password': {
        getState().setPassword(command.data.value);
        break;
      }

      case 'login': {
        getState().signIn();
        break;
      }

      case 'send_password_reset_code': {
        getState().sendResetCode(getState().username);
        break;
      }

      case 'set_password_mode': {
        getState().setPasswordMode(command.data.value);
        break;
      }
    }
  }
}
